<div class="mt-3" *ngFor="let multiCode of multiCodes; let i = index">
    <span>{{ (i === 0 ? 'pt.edp.edponline.widget.code.generation.modal.multicodes.1.label' :
        (i === 1 ? 'pt.edp.edponline.widget.code.generation.modal.multicodes.2.label' :
        'pt.edp.edponline.widget.code.generation.modal.multicodes.3.label')) | translate }}</span>
    <span *ngIf="i === 0">{{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.1.requirement' | translate }}</span>
    <ng-container *ngIf="i > 0">
        <span *ngIf="multiCode.generatedCodes || multiCode.validated">
            {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.1.requirement' | translate }}
            {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.and' | translate }}
            {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.2.requirement' | translate }}
            {{ (i === 1 ? 'pt.edp.edponline.widget.code.generation.modal.multicodes.or' :
            'pt.edp.edponline.widget.code.generation.modal.multicodes.and') | translate }}
            {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.3.requirement' | translate }}</span>
        <span *ngIf="!multiCode.generatedCodes && !multiCode.validated">
            {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.1.requirement' | translate }}
            {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.and' | translate }}
            
            <span *ngIf="appliedConditions.HAS_E_INVOICE">
                {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.2.requirement' | translate }}
            </span>
                        
            <a *ngIf="!appliedConditions.HAS_E_INVOICE" (click)="close()" [routerLink]="['/local-pagamento-condicoes']" class="link edp-text-seaweed-green">
                {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.2.requirement' | translate }}
            </a>
            
            {{ (i === 1 ? 'pt.edp.edponline.widget.code.generation.modal.multicodes.or' :
                'pt.edp.edponline.widget.code.generation.modal.multicodes.and') | translate }}
            
            <ng-container *ngIf="appliedConditions.HAS_E_INVOICE && appliedConditions.BUSINESS_AGREEMENTS">
                <a (click)="close()" [routerLink]="['/comunicacoes-consentimentos']" class="link edp-text-seaweed-green">             
                {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.3.requirement' | translate }}</a> 
            </ng-container> 
            <ng-container *ngIf="!appliedConditions.HAS_E_INVOICE && appliedConditions.BUSINESS_AGREEMENTS">                            
                {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.3.requirement' | translate }}
            </ng-container>
            <ng-container *ngIf="!appliedConditions.HAS_E_INVOICE && !appliedConditions.BUSINESS_AGREEMENTS">
                <a (click)="close()" [routerLink]="['/comunicacoes-consentimentos']" class="link edp-text-seaweed-green">             
                {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.3.requirement' | translate }}</a> 
            </ng-container>
            <ng-container *ngIf="appliedConditions.HAS_E_INVOICE && !appliedConditions.BUSINESS_AGREEMENTS">
                <a (click)="close()" [routerLink]="['/comunicacoes-consentimentos']" class="link edp-text-seaweed-green">             
                {{ 'pt.edp.edponline.widget.code.generation.modal.multicodes.3.requirement' | translate }}</a> 
            </ng-container>
        </span>
    </ng-container>
    <ng-container *ngIf="multiCode.generatedCodes || multiCode.validated">
        <i class="ml-1 icon-edponline-Bop-072 icon align-self-center font-weight-bold icon-check" aria-hidden="true"></i>
        <span *ngIf="multiCode.generatedCodes" class="d-block font-weight-bold">{{multiCode.generatedCodes.code}}</span>
    </ng-container>
</div>